"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import "dayjs/locale/en";
import "dayjs/locale/zh-cn";
import "dayjs/locale/zh-tw";
import { useLocale } from "next-intl";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
dayjs.extend(utc);
dayjs.extend(timezone);
const dayjsLocaleByAppLocale: Record<string, string> = {
  "en-US": "en",
  "zh-Hans": "zh-cn",
  "zh-Hant": "zh-tw"
};
export interface IProps extends React.ComponentPropsWithoutRef<"span"> {}
export const Now: React.FC<IProps> = () => {
  const $ = _c(7);
  const locale = useLocale();
  const [now, setNow] = useState(_temp);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const timer = window.setInterval(() => setNow(dayjs()), 1000);
      return () => {
        window.clearInterval(timer);
      };
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  const djLocale = dayjsLocaleByAppLocale[locale] ?? "en";
  let t2;
  if ($[2] !== djLocale || $[3] !== now) {
    t2 = now.tz("Asia/Taipei").locale(djLocale).format("dddd YYYY-MM-DD HH:mm:ss");
    $[2] = djLocale;
    $[3] = now;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const text = t2;
  let t3;
  if ($[5] !== text) {
    t3 = <span suppressHydrationWarning={true} data-sentry-component="Now" data-sentry-source-file="Now.tsx">{text}</span>;
    $[5] = text;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
function _temp() {
  return dayjs();
}